<template>
  <div>
    <div class="swiper-container home_banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in List" :key="index">
          <div class="top_div">
            <img :src="item.img" />
            <div class="div_top_title">
              <p>{{ item.titleCn }}</p>
              <p class="p_title_en">{{ item.titleEn }}</p>
              <p class="p_title_en">{{ item.titleEnSub }}</p>
              <p class="p_title_sub">{{ item.contentCn }}</p>
              <p class="p_title_sub">{{ item.contentCnSub }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination home_pagination"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      List: [
        {
          titleCn:'',
          contentCnSub:'',
          titleEn:'',
          titleEnSub:'',
          img:'',
        }
      ],
    };
  },
  created() {},
  watch: {
    //监听轮播数据变化后再创建实例
    List() {
      this.$nextTick(() => {
      this.playMultipleBanner();
    });
    },
  },
  computed: {},
  mounted() {
    this.getBanner();
    // this.playMultipleBanner();
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    playMultipleBanner() {
      var swiper = new Swiper(".home_banner", {
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".home_pagination",
          clickable: true,
        },
      });
    },
    getBanner() {
      let that = this;
      this.$axios
        .get("app/homebanner/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.List = response.data.page.list;
            console.log(that.List);
            // sessionStorage.setItem("input", "null");
          }
          // console.log("that.List");
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
<style lang="stylus" scoped>
.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: #FFFFFF;
  height: 93rem;

  div {
    width: 100%;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.top_div {
  height: 100%;
  position: relative;
}

.div_top_title {
  position: absolute;
  left: 20rem;
  bottom: 5rem;
  color: white;
  font-size: 3.6rem;
  font-family: medium;
  text-align: left;

  .p_title_sub {
    line-height:2.5rem;
    font-size: 2rem;
    font-family: light;
  }

  .p_title_en {
    line-height:7.2rem;
    font-size: 7.2rem;
    font-family: bin_num_din;
  }
}

@media screen and (max-width: 1200px) {
  .home_banner {
    padding-top:60px;
    height:50vh;
    
  }
  .div_top_title {
    left:3rem;
    bottom:3rem;
    font-size:2.6rem;

    .p_title_sub {
    line-height:2.2rem;
    font-size: 1.6rem;
  }

  .p_title_en {
    line-height:5rem;
    font-size: 5rem;
  }
  }
}
</style>